<template>
    <div
        @mouseout="onMouseOut"
        @mouseover="onMouseOver"
    >
        <div
            ref="sidebarMetricDisplay"
            class="cursor-default rounded hover:bg-secondary/10 border border-base-300 hover:border-secondary transition-all duration-200 p-1"
        >
            <div ref="metricTitle" class="text-sm opacity-70 uppercase">
                {{ title }}
            </div>
            <div class="flex items-baseline justify-between">
                <template v-if="shouldShowRate">
                    <div class="text-lg">
                        {{ formatCurrency(rate, 1) }} %
                    </div>
                </template>
                <div v-else />
                <div class="text-lg mt-0 text-right">
                    {{ formatCurrency(amount, 0) }} <span class="text-sm opacity-60">NOK</span>
                </div>
            </div>
        </div>
        <div
            ref="floatingContent"
            :style="popoverStyle"
            class="rounded shadow-lg max-w-96 border border-secondary card bg-base-100 flex-col p-1 px-2 transition-all duration-200"
        >
            <div class="text-lg border-b">{{ title }}</div>
            <div class="grow overflow-y-auto py-1 pb-4 border-b gap-4 flex flex-col">
                {{ description }}
                <div v-if="shouldShowRate">
                    <span class="text-lg mr-2">{{ formatCurrency(rate, 1) }} %:</span>{{ title }} som andel av driftsinntekt.
                </div>
            </div>
            <div class="footer flex flex-col gap-1">
                <div class="opacity-50 hover:underline flex items-center gap-1">
                    <i class="i-mdi-robot text-lg"/>
                    <span>Spør ContaAI</span> (kommer snart)
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {formatCurrency} from '@/services/formatter.service'
import {autoUpdate, shift, useFloating} from '@floating-ui/vue'
import {computed, ref} from 'vue'

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    amount: {
        type: Number,
        required: true
    },
    rate: {
        type: Number,
        required: false
    },
    description: {
        type: String,
        default: ''
    }
})

const shouldShowRate = computed(() => {
    return props.rate !== undefined && isFinite(props.rate) && Math.abs(props.rate) > 0.001
})

const sidebarMetricDisplay = ref<HTMLElement | null>(null)
const floatingContent = ref<HTMLElement | null>(null)
const {floatingStyles} = useFloating(sidebarMetricDisplay, floatingContent, {
    placement: 'right-start',
    whileElementsMounted: autoUpdate,
    middleware: [
        shift({
            crossAxis: true
        })
    ]
})
const showFloating = ref(false)

const popoverStyle = computed(() => {
    return {
        ...floatingStyles.value,
        zIndex: 1,
        opacity: showFloating.value ? '100' : '0',
        display: showFloating.value ? 'flex' : 'none'
    }
})

const onMouseOver = () => {
    showFloating.value = true
}

const onMouseOut = () => {
    showFloating.value = false
}

</script>

<style scoped>

</style>